import { showConfigureActions } from '../../services';

export const showConfigureReducer = (state={show:false, component:"", leave:false, updated:false}, action)=>{
    switch(action.type){
        case showConfigureActions.SHOW:
            return {...state, ["show"]:true, ["component"]:action.component};
        case showConfigureActions.HIDE:
            return {...state, ["show"]:false,["leave"]:false, ["component"]:"", ["updated"]:false};
        case showConfigureActions.LEAVE:
            return {...state,["leave"]:true};
        case showConfigureActions.STAY:
            return {...state,["leave"]:false};
        case showConfigureActions.UPDATE:
            return {...state,["updated"]:action.update};
        default:
            return state;
        }
}